import { axiosInstance } from "../apiurls/apiurls";
import {
  GET_ALL_SUBJECTS,
  GET_SUBJECT_BY_KEY,
  GET_ALL_SUBJECT_PAGE_CONTENT,
  GET_SUBJECT_PAGE_CONTENT_BY_ID,
  GET_ALL_SUBJECT_INSTITUTION_PAGE_CONTENT,
  GET_SUBJECT_INSTITUTION_PAGE_CONTENT_BY_ID,
  GET_ONE_SUBJECT_COMPLETED_URL,
} from "../apiurls/apiurls";

export const getAllSubjects = async (courseKey) => {
  try {
    const response = await axiosInstance.get(
      `${GET_ALL_SUBJECTS}?course_key=${courseKey}`
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching subjects:", error);
    throw error;
  }
};

export const getSubjectByKey = async (key) => {
  try {
    const response = await axiosInstance.get(
      `${GET_SUBJECT_BY_KEY}?key=${key}`
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching subject by key:", error);
    throw error;
  }
};

export const getAllSubjectPageContent = async (subjectKey) => {
  try {
    const response = await axiosInstance.get(
      `${GET_ALL_SUBJECT_PAGE_CONTENT}?subject_key=${subjectKey}`
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching all subject page content:", error);
    throw error;
  }
};

export const getSubjectPageContentById = async (id) => {
  try {
    const response = await axiosInstance.get(
      `${GET_SUBJECT_PAGE_CONTENT_BY_ID}?id=${id}`
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching subject page content by id:", error);
    throw error;
  }
};

export const getAllSubjectInstitutionPageContent = async (subjectKey) => {
  try {
    const response = await axiosInstance.get(
      `${GET_ALL_SUBJECT_INSTITUTION_PAGE_CONTENT}?subject_key=${subjectKey}`
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching all subject institution page content:", error);
    throw error;
  }
};

export const getSubjectInstitutionPageContentById = async (id) => {
  try {
    const response = await axiosInstance.get(
      `${GET_SUBJECT_INSTITUTION_PAGE_CONTENT_BY_ID}?id=${id}`
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching subject institution page content by id:", error);
    throw error;
  }
};

export const getOneSubjectCompletedApi = async (pageId) => {
  try {
    const response = await axiosInstance.get(
      `${GET_ONE_SUBJECT_COMPLETED_URL}?page_id=${pageId}`
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching one subject completed:", error);
    throw error;
  }
};
